module.exports = __webpack_public_path__ + "img/legacy-shape-3.e1eaa0d2.png";